module.exports = __webpack_public_path__ + "static/img/6.8ac5330.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/2/5/eng/6.png
// module id = 8X3t
// module chunks = 0